export default {_name:'chart.cartesian',module:'Card/Form',view:'Element/Chart/Cartesian',options:{key:'cartesianChart'}}